import React, { useState } from 'react';
import './Branching.css';

function Branching() {
  const [step, setStep] = useState(0);

  const branchSteps = [
    {
      title: '1. Branca principal (main)',
      desc: 'Tot comenca amb la branca main. Es la linia principal de desenvolupament.',
      branches: [
        { name: 'main', commits: ['C1', 'C2', 'C3'], color: '#22c55e', active: true },
      ],
    },
    {
      title: '2. Crear una branca nova',
      desc: 'Creem una branca feature-login per treballar en la funcionalitat de login sense afectar main.',
      branches: [
        { name: 'main', commits: ['C1', 'C2', 'C3'], color: '#22c55e', active: false },
        { name: 'feature-login', commits: ['C1', 'C2', 'C3'], color: '#3b82f6', active: true, branchFrom: 2 },
      ],
    },
    {
      title: '3. Treballar a la branca',
      desc: 'Fem commits a la branca feature-login. La branca main no es veu afectada.',
      branches: [
        { name: 'main', commits: ['C1', 'C2', 'C3'], color: '#22c55e', active: false },
        { name: 'feature-login', commits: ['C1', 'C2', 'C3', 'C4', 'C5'], color: '#3b82f6', active: true, branchFrom: 2 },
      ],
    },
    {
      title: '4. Merge (fusionar)',
      desc: 'Quan la funcionalitat esta llesta, fusionem feature-login amb main. Tots els canvis sintegren.',
      branches: [
        { name: 'main', commits: ['C1', 'C2', 'C3', 'C4', 'C5', 'M'], color: '#22c55e', active: true, merged: true },
        { name: 'feature-login', commits: ['C1', 'C2', 'C3', 'C4', 'C5'], color: '#3b82f6', active: false, branchFrom: 2, mergedAt: 5 },
      ],
    },
  ];

  const current = branchSteps[step];

  return (
    <section id="branching" className="branching">
      <div className="container">
        <div className="section-header">
          <span className="section-tag">Branques</span>
          <h2 className="section-title">Branching i <span className="gold">Merging</span></h2>
          <p className="section-desc">
            Les branques permeten treballar en funcionalitats aïllades.
            Entendre el branching es fonamental per al treball en equip.
          </p>
        </div>

        <div className="branch-visualization">
          <div className="branch-controls">
            {branchSteps.map((s, i) => (
              <button
                key={i}
                className={`branch-step-btn ${step === i ? 'active' : ''} ${i < step ? 'completed' : ''}`}
                onClick={() => setStep(i)}
              >
                <span className="step-num">{i + 1}</span>
                <span className="step-text">{s.title.split('. ')[1]}</span>
              </button>
            ))}
          </div>

          <div className="branch-canvas">
            <div className="branch-info">
              <h3>{current.title}</h3>
              <p>{current.desc}</p>
            </div>

            <div className="branch-graph">
              {current.branches.map((branch, bi) => (
                <div key={bi} className={`branch-row ${branch.active ? 'active' : ''}`}>
                  <div className="branch-name" style={{ background: branch.color }}>
                    {branch.name}
                  </div>
                  <div className="branch-line">
                    {branch.commits.map((commit, ci) => {
                      const isBranchPoint = branch.branchFrom !== undefined && ci === branch.branchFrom;
                      const isMergePoint = commit === 'M';
                      const isBeforeBranch = branch.branchFrom !== undefined && ci <= branch.branchFrom;

                      return (
                        <div
                          key={ci}
                          className={`commit-node ${isMergePoint ? 'merge' : ''} ${branch.active && ci === branch.commits.length - 1 ? 'head' : ''}`}
                          style={{
                            '--node-color': branch.color,
                            opacity: (bi > 0 && isBeforeBranch && !isBranchPoint) ? 0 : 1,
                            visibility: (bi > 0 && isBeforeBranch && !isBranchPoint) ? 'hidden' : 'visible',
                          }}
                        >
                          <div className="node-dot"></div>
                          <span className="node-label">{isMergePoint ? 'Merge' : commit}</span>
                          {isBranchPoint && bi > 0 && (
                            <div className="branch-connector">
                              <svg width="2" height="40" viewBox="0 0 2 40">
                                <line x1="1" y1="0" x2="1" y2="40" stroke={branch.color} strokeWidth="2" strokeDasharray="4"/>
                              </svg>
                            </div>
                          )}
                          {branch.mergedAt !== undefined && ci === branch.commits.length - 1 && (
                            <div className="merge-connector">
                              <svg width="2" height="40" viewBox="0 0 2 40">
                                <line x1="1" y1="0" x2="1" y2="40" stroke={branch.color} strokeWidth="2" strokeDasharray="4"/>
                              </svg>
                            </div>
                          )}
                        </div>
                      );
                    })}
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="branch-nav">
            <button
              className="nav-btn"
              onClick={() => setStep(Math.max(0, step - 1))}
              disabled={step === 0}
            >
              Anterior
            </button>
            <div className="nav-dots">
              {branchSteps.map((_, i) => (
                <span key={i} className={`nav-dot ${step === i ? 'active' : ''}`}></span>
              ))}
            </div>
            <button
              className="nav-btn primary"
              onClick={() => setStep(Math.min(branchSteps.length - 1, step + 1))}
              disabled={step === branchSteps.length - 1}
            >
              Seguent
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Branching;
